const { getAxiosInstance } = require('../connection');

module.exports = {
    fetch() {
        return getAxiosInstance({
            url:  '/notifications',
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
    markRead(id) {
        return getAxiosInstance({
            url:  '/notifications/' + encodeURIComponent(id),
            method: 'PUT',
            json: true,
        }).then((response) => response.data);
    },
};
